import { render, staticRenderFns } from "./TopicMessage.vue?vue&type=template&id=f5ca1bbc"
import script from "./TopicMessage.vue?vue&type=script&lang=js"
export * from "./TopicMessage.vue?vue&type=script&lang=js"
import style0 from "./TopicMessage.vue?vue&type=style&index=0&id=f5ca1bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
